import React from "react";
import { Table, Spinner, Badge, Stack } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  Check2Circle,
  XCircleFill,
  PencilSquare,
  Trash
} from "react-bootstrap-icons";
import { formatDate, formatShortDate, formatSmartDate, hasDatePassed, shortText } from "../../../utils/helper_functions";

function ContentTableList({
  tableData = [],
  handleEditTableRow,
  handleDeleteTableRow,
  isLoading
}) {
  //
  return (
    <div>
      {isLoading && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}
      <Table
        hover
        responsive
        striped
        style={{ opacity: isLoading ? 0.5 : 1, transition: "opacity 0.2s" }}
      >
        <thead>
          <tr>
            <td className="d-none d-md-table-cell">
              ID
            </td>

            <td>
              Message
            </td>
            
            <td className="d-none d-md-table-cell">
              Start Date
            </td>
            <td className="d-none d-md-table-cell">
              End Date
            </td>
            <td className="d-none d-md-table-cell">
              Active
            </td>
            <td className="d-none d-md-table-cell">
              Created
            </td>
            
            {(typeof handleEditTableRow === "function" ||
              typeof handleDeleteTableRow === "function") && (
              <td style={{ whiteSpace: "nowrap", textAlign: "right" }}>
                Actions
              </td>
            )}
          </tr>
        </thead>
        <tbody>
          {!tableData || tableData?.data?.data?.results.length < 1 ? (
            <tr>
              <td colSpan="10">
                <center>
                  <strong style={{ color: "orange" }}>
                    No Records To Display{" "}
                  </strong>
                </center>
              </td>
            </tr>
          ) : (
            tableData?.data?.data?.results.map((data, index) => (
              <tr key={index}>
                <th className="d-none d-md-table-cell">
                  {" "}
                  <Link
                    // to={"/accounts/profile" + item.id}
                    to="#"
                    state={{ contentId: data?.id }}
                    className="text-decoration-none"
                  >
                    {index + 1}
                  </Link>
                </th>
                <td style={{maxWidth:250}}>{shortText(data?.message, 50)}<br/>
                <Badge bg="info">{data?.keyword}</Badge><br/>
                <small className='d-md-none'>from {formatDate(data?.start_date)} - {formatDate(data?.end_date)}</small><br/>
                </td>
                <td className="d-none d-md-table-cell">
                  {formatDate(data?.start_date)}
                </td>
                <td className="d-none d-md-table-cell">{formatDate(data?.end_date)}</td>
                <td className="d-none d-md-table-cell">
                  {!hasDatePassed(data?.end_date) ? (
                     <Check2Circle color="green" />
                  ) : (
                    <XCircleFill color="warning" />
                  )}
                </td>
                <td className="d-none d-md-table-cell">{formatSmartDate(data?.created)}</td>
               
                {(typeof handleEditTableRow === "function" ||
                  typeof handleDeleteTableRow === "function") && (
                  <td align="center">
                      <Stack direction="horizontal" gap={1}>
                      {typeof handleEditTableRow === "function" && (
                        <PencilSquare
                          style={{
                            cursor: isLoading ? "not-allowed" : "pointer",
                            color: isLoading ? "gray" : "blue",
                            opacity: isLoading ? 0.5 : 1,
                            marginRight: "1rem"
                          }}
                          onClick={
                            isLoading ? null : () => handleEditTableRow(data)
                          }
                        />
                      )}

                      {typeof handleDeleteTableRow === "function" && (
                        <Trash
                          className="d-none d-md-block"
                          style={{
                            cursor: isLoading ? "not-allowed" : "pointer",
                            color: isLoading ? "gray" : "red",
                            opacity: isLoading ? 0.5 : 1
                          }}
                          onClick={
                            isLoading ? null : () => handleDeleteTableRow(data)
                          }
                        />
                      )}
                   </Stack>
                  </td>
                )}
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </div>
  );
}

export default ContentTableList;
